import { ActionType } from "models/messagemanagement/updateMessage";

export const updateMessageAction = (payload: any) => {
  return {
    type: ActionType.UPDATE_MESSAGE,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.UPDATE_MESSAGE_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: any) => {
  return {
    type: ActionType.UPDATE_MESSAGE_SUCCESS,
    payload,
  };
};

export const handleResetAction = () => {
  return {
    type: ActionType.RESET_UPDATE_MESSAGE,
  };
};
